import { useContext } from 'react';

import { SectionSettingsContext } from '../context';

export const useSectionSettings = () => useContext(SectionSettingsContext);
